<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <h6 class="m-0">
        {{ $l('form_header_contacts') || '客户联系人' }}
      </h6>
      <el-divider direction="vertical" />
      <b-button size="sm" variant="outline-success" @click="addContacts">
        {{ $l('btn_addContacts') || '新增联系人' }}
      </b-button>
    </div>

    <div class="cust-contacts-list">
      <el-form
        v-for="(form, index) in listContacts"
        :key="index"
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
      >
        <div class="d-flex">
          <div>
            <div @click="uploadAvatar(index)">
              <el-avatar
                shape="square"
                :src="form.contactAvatarUrl || defaultAvatar"
              />
            </div>
            <div class="text-center mt-2">
              <el-tooltip
                effect="dark"
                :content="$l('INDEX.btn_tips_del') || '删除'"
                placement="left-end"
              >
                <i
                  class="el-icon-delete text-danger tool-btn"
                  style="font-size: larger;"
                  @click="deleteContacts(index)"
                />
              </el-tooltip>
            </div>
          </div>
          <div style="flex:1;padding-left: 16px;">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_create_contactName') || '姓名'"
                  prop="contactName"
                >
                  <el-input
                    v-model="form.contactName"
                    :placeholder="
                      $l('form_placeholder_create_contactName') || '请输入姓名'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_create_contactJob') || '职务'"
                  prop="contactJob"
                >
                  <el-input
                    v-model="form.contactJob"
                    :placeholder="
                      $l('form_placeholder_create_contactJob') || '请输入职务'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_create_contactMobile') || '联系电话'"
                  prop="contactMobile"
                >
                  <el-input
                    v-model="form.contactMobile"
                    :placeholder="
                      $l('form_placeholder_create_contactMobile') ||
                        '请输入联系电话'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_create_contactEmail') || '邮件地址'"
                  prop="contactEmail"
                >
                  <el-input
                    v-model="form.contactEmail"
                    :placeholder="
                      $l('form_placeholder_create_contactEmail') ||
                        '请输入邮件地址'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_create_contactPhone') || '固定电话'"
                >
                  <el-input
                    v-model="form.contactPhone"
                    :placeholder="
                      $l('form_placeholder_create_contactPhone') ||
                        '请输入固定电话'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_create_contactAddress') || '通讯地址'"
                  prop="contactAddress"
                >
                  <el-input
                    v-model="form.contactAddress"
                    :placeholder="
                      $l('form_placeholder_create_contactAddress') ||
                        '请输入通讯地址'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_create_contactMemo') || '业务职责说明'"
                >
                  <el-input
                    v-model="form.contactMemo"
                    :placeholder="
                      $l('form_placeholder_create_contactMemo') ||
                        '请输入业务职责说明'
                    "
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { VXETable } from 'vxe-table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
const initContacts = {
  contactAvatarUrl: '',
  contactAvatarCode: '',
}
export default {
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      listContacts: [],
      rules: {
        contactName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_create_contactName') || '请输入姓名',
            trigger: 'change',
          },
        ],
        contactJob: [
          {
            required: true,
            message:
              this.$l('form_placeholder_create_contactJob') || '请输入职务',
            trigger: 'change',
          },
        ],
        contactMobile: [
          {
            required: true,
            message:
              this.$l('form_placeholder_create_contactMobile') ||
              '请输入联系电话',
            trigger: 'change',
          },
        ],
        contactEmail: [
          {
            required: true,
            message:
              this.$l('form_placeholder_create_contactEmail') ||
              '请输入邮件地址',
            trigger: 'change',
          },
        ],
        contactAddress: [
          {
            required: true,
            message:
              this.$l('form_placeholder_create_contactAddress') ||
              '请输入通讯地址',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerContactsListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.listContacts = res.body?.data || []
      if (!this.listContacts?.length) this.addContacts()
    },
    addContacts() {
      this.listContacts.push({ ...initContacts })
    },
    async deleteContacts(index) {
      if (!this.listContacts?.length) return

      if (this.listContacts.length === 1) {
        this.$message({
          message:
            this.$l('tips_warning_deleteContacts') ||
            '无法删除当前联系人，客户至少需要存在一个联系人！',
          type: 'warning',
        })
        return false
      }

      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listContacts.splice(index, 1)
    },
    async uploadAvatar(index) {
      const { file } = await VXETable.readFile({
        types: ['jpeg', 'JPEG', 'jpg', 'JPG', 'png', 'PNG', 'gif', 'GIF'],
      }).catch(() => ({}))
      if (!file) return

      if (this.loadingOpen()) return

      const avatar = await this.$api
        .SYS_UPLOAD(file)
        .then((res) => ({
          fileCode: res.body.fileId,
          fileUrl: res.body.url,
        }))
        .catch(() => null)
      this.loadingClose()
      if (!avatar) return

      this.listContacts[index].contactAvatarCode = avatar.fileCode
      this.listContacts[index].contactAvatarUrl = avatar.fileUrl
    },
    validate() {
      if (!this.listContacts?.length) {
        this.$message({
          message:
            this.$l('tips_warning_contactsEmpty') || '请添加一位联系人！',
          type: 'warning',
        })
        return false
      }
      return validate.formValidate(this.$refs.form)
    },
    async complete() {
      if (!(await this.validate())) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerSaveContactsApi({
          listContacts: this.listContacts,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return false

      if (res.status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-avatar {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }

  .cust-contacts-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
